import { TrashIcon } from "@heroicons/react/solid";
import { FunctionComponent, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "../../../components/buttons";
import { IModalContentProps } from "../../../models/modals";
import { ToastType } from "../../../models/toast";
import { WorkspaceInvite } from "../../../models/workspace";
import { useAppDispatch } from "../../../reducers";
import { useDeleteWorkspaceInviteMutation } from "../../../services/endpoints/workspaces";
import { showToast } from "../../toasts/toastsSlice";

interface IDeleteWorkspaceInvitationModal {
  invite: WorkspaceInvite;
}

const DeleteWorkspaceInvitationModal: FunctionComponent<IDeleteWorkspaceInvitationModal & IModalContentProps> = ({ invite, closeModal }) => {
  const { t } = useTranslation('company');
  const dispatch = useAppDispatch();

  const [deleteInvite, { isLoading, isSuccess }] = useDeleteWorkspaceInviteMutation();

  const handleDeleteClicked = () => {
    deleteInvite({ workspaceId: invite.workspaceId, id: invite.id });
  };

  useEffect(() => {
    if (isSuccess) {
      closeModal();
      dispatch(
        showToast({
          type: ToastType.SUCCESS,
          title: t('invite.delete.successful_title'),
          message: t('invite.delete.successful_message', { email: invite.invitedEmail }),
        })
      );
    }
  }, [isSuccess]);

  return (
    <div className='flex justify-center h-60 '>
      <div className='max-w-4xl my-auto text-left p-5'>
        <h1 className='text-lg text-black-100 font-semibold mb-5'>{t('invite.delete.delete_title')}</h1>
        <p className='text-base'>
          {t('invite.delete.delete_confirm')}&nbsp;(<b>{invite.invitedEmail}</b>)
        </p>
        <Button className="mt-3" icon={TrashIcon} variant='delete' onClick={handleDeleteClicked} loading={isLoading} >
          {t('invite.delete.delete_button_title')}
        </Button>
      </div>
    </div>
  );
};

export default DeleteWorkspaceInvitationModal;
